import { useEffect, useState } from 'react';

export function useImageUrl(file: unknown): string | undefined {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    let id: number | undefined;
    if (file instanceof File && file.type.startsWith('image/')) {
      id = requestAnimationFrame(() => {
        setUrl(URL.createObjectURL(file));
      });
    }
    return () => {
      if (id !== undefined) cancelAnimationFrame(id);
      setUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return undefined;
      });
    };
  }, [file]);

  return url;
}
